import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M1.5 11.25a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 1 0-7.5 0M15 6a3.75 3.75 0 1 0 7.5 0A3.75 3.75 0 1 0 15 6m0 12a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 1 0-7.5 0M8.746 9.891l6.508-2.531m-6.649 5.568 6.79 3.395"
    }, null, -1)
  ]));
}
const interfaceShare = { render };
export {
  interfaceShare as default,
  render
};
//# sourceMappingURL=interface-share.svg.js.map
